import React, { useEffect, useState } from 'react';
import { Deduction, TypeOfDeductionsValues } from '../../../../app/models/Deduction';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { setCleanTextAreaError } from '../../../../utils/utils';

interface Props {
    deductionForm: Deduction;
    setDeductionForm: (deduction: Deduction) => void;
    errorFields?: any;
    setErrorFields?: (errors: any) => void;
}

const DeductionForm = ({
    deductionForm,
    setDeductionForm,
    errorFields,
    setErrorFields
}: Props) => {
    
    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        setDeductionForm({ ...deductionForm, [name]: value });
    };


    return (
        <>
            <div className="mb-2 row needs-validation">

                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={deductionForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre de la deducción"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>

                <div className="col-md-12">
                    <label className="col-form-label">Descripción</label>
                    <textarea
                        className={`form-control ${fieldHasError('description')}`}
                        name="description"
                        id="description"
                        value={deductionForm.description}
                        onChange={handleChange}
                        placeholder="Ingrese una descripción"
                        onFocus={setCleanTextAreaError}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('description')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeductionForm;
